<script>
import ImgGrid from '~/components/ImgGrid'

export default {
  components: {
    ImgGrid
  },
  props: {
    width: {
      type: Number,
      default: 0
    },
    evaluate: {
      default: () => {
        return {}
      },
      type: Object
    }
  },
  data() {
    return {
      EventItemWidth: ''
    }
  },
  created() {
    this.EventItemWidth = this.width
  }
}
</script>
<template>
  <div class="project_rating_list_item_container">
    <img :src="evaluate.imgUrlOssUrl" class="rating_person_img" />
    <div class="project_rating_right_container bottom_line_L_R">
      <div class="project_rating_rt_container">
        <span class="project_rating_rt_l">{{ evaluate.nickName }}</span>
        <span class="project_rating_rt_r">{{ evaluate.evaluatTime }}</span>
      </div>
      <div class="count_container">
        <span>评分:</span>
        <no-ssr>
          <star-rating
            :read-only="true"
            :show-rating="false"
            :rating="evaluate.avgValue"
            :star-size="12"
          />
        </no-ssr>
      </div>
      <div class="info_container">
        <span>施工:{{ evaluate.qualityValue }}</span>
        <span>设计:{{ evaluate.designCapabilityValue }}</span>
        <span>价格:{{ evaluate.costPerformanceValue }}</span>
      </div>
      <p class="comment_container">{{ evaluate.desc }}</p>
      <ImgGrid :width="EventItemWidth" :images="evaluate.mediaList" />

      <span class="mark_container">完工评价</span>

      <div
        v-if="evaluate.replyList && evaluate.replyList[0]"
        class="reply_comment_container"
      >
        <span class="reply_comment_container-title">商家回复:</span>
        <tr class="hide_on_mobile" />
        <div class="hide_on_mobile" style="height:6px;" />
        <span class="reply_comment_container-text">{{
          evaluate.replyList[0].commentText
        }}</span>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.bottom_line_L_R {
  position: relative;
}
.bottom_line_L_R::after {
  position: absolute;
  bottom: -25px;
  left: 15px;
  right: 0;
  display: block;
  background: #eff1f2;
  content: '';
  height: 1px;
  transform: scale(1, 0.5);
  -webkit-transform: scale(1, 0.5);
}

@media screen and (min-width: 940px) {
  .project_rating_list_item_container {
    width: 100%;
  }

  .rating_person_img {
    display: inline-block;
    height: 55px;
    width: 55px;

    border-radius: 100%;
  }
}

.project_rating_list_item_container {
  // padding-top: 25px !important;
  display: flex;
  position: relative;
  width: 100%;
  // border: 1px solid red;
  padding-bottom: 25px !important;

  .rating_person_img {
    display: inline-block;
    height: 40px;
    width: 40px;
    border-radius: 100%;
  }

  .project_rating_right_container {
    padding-left: 15px;
    width: 100%;
  }

  .project_rating_rt_container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;

    .project_rating_rt_l {
      display: inline-block;
      font-size: 16px;
      color: rgba(42, 42, 42, 1);
      line-height: 16px;
    }

    .project_rating_rt_r {
      display: inline-block;
      font-size: 14px;
      color: rgba(155, 155, 155, 1);
      line-height: 14px;
    }
  }

  .count_container {
    padding-top: 10px;
    font-size: 12px;
    color: rgba(155, 155, 155, 1);
    line-height: 12px;
    display: flex;
  }

  .info_container {
    padding-top: 10px;
    font-size: 12px;
    color: rgba(155, 155, 155, 1);
    line-height: 12px;
  }

  .comment_container {
    white-space: pre-wrap;
    padding-top: 10px;
    font-size: 14px;
    line-height: 20px;
    color: rgba(42, 42, 42, 1);
  }

  .mark_container {
    display: inline-block;
    padding: 3px 5px;
    font-size: 12px;
    color: rgba(155, 155, 155, 1);
    line-height: 12px;
    background: rgba(244, 244, 244, 1);
    border-radius: 2px;
    margin-top: 10px;
  }
}

.reply_comment_container {
  margin-top: 10px !important;
  padding: 15px !important;
  border-radius: 4px;
  background-color: #f4f4f4;
}
.reply_comment_container-title {
  font-size: 14px;
  font-weight: 500;
  color: #666666;
  line-height: 20px;
}
.reply_comment_container-text {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  white-space: pre-wrap;

  line-height: 20px;
}

@media screen and (max-width: 940px) {
  .reply_comment_container {
    margin-top: 10px !important;
    padding: 12px 10px !important;
  }
  .reply_comment_container-text {
    line-height: 19px;
  }
}
</style>
